<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-30 11:01:22
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2022-01-10 10:43:37
-->
<template>
  <el-dialog
    v-dialogDrag
    title="操作信息"
    :visible.sync="dialogVisible"
    width="60%"
    top="5vh"
    class="self-dialog-form"
  >
    <template>
      <el-descriptions direction="vertical" :column="5" border>
        <el-descriptions-item label="系统模块">{{ dialogData.module }}</el-descriptions-item>
        <el-descriptions-item label="标题">{{ dialogData.title }}</el-descriptions-item>
        <el-descriptions-item label="请求方式">{{ dialogData.requestMethod }}</el-descriptions-item>
        <el-descriptions-item label="请求IP">{{ dialogData.remoteIp }}</el-descriptions-item>
        <el-descriptions-item label="操作时间">{{ dialogData.createTime }}</el-descriptions-item>
        <el-descriptions-item label="操作类型">{{ dialogData.logType }}</el-descriptions-item>
        <el-descriptions-item label="操作人">{{ dialogData.operator }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ dialogData.requestState }}</el-descriptions-item>
        <el-descriptions-item label="耗时(毫秒)" :span="2">
          {{ dialogData.duration }}
        </el-descriptions-item>
        <el-descriptions-item label="请求地址" :span="5">
          {{ dialogData.requestUri}}
        </el-descriptions-item>
        <el-descriptions-item label="请求参数" :span="5">
          {{ dialogData.requestParam }}
        </el-descriptions-item>
        <el-descriptions-item label="日志信息(内容)" :span="5">
          {{ dialogData.logContent }}
        </el-descriptions-item>
      </el-descriptions>
      <!-- <el-row>{{ dialogData }}</el-row> -->
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "LogDetailsDialog",
  props: {
    visible: {
      type: [Boolean],
      default: false
    },
    dialogData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    logsInfo() {
      return this.visible;
    }
  },
  watch: {},
  created() {},
  mounted() {}
};
</script>

<style lang="scss">
.el-descriptions {
  margin-bottom: 30px;
}
.el-descriptions-item__label.is-bordered-label {
  color: #21252e;
}
.el-descriptions-item__content {
  color: #505363;
}
.el-descriptions-row {
  height: 46px;
}
</style>
